import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import * as css from 'styles'

import { IconButton, Modal, Input, Grid, Img } from 'components'

const Share = ({ 
  url = document.location.href,
  text = '', 
  image = false,
  color = css.color.black,
}) => {
  const dispatch = useDispatch()
  const name = `fallback-share-menu${url}`

  const handleClick = (e) => {
    if (e) e.preventDefault();
    if (navigator.share) {
      navigator.share({
        title: 'Art in Res',
        text,
        url,
      })
        .then(() => console.log('Successful share'))
        .catch((error) => console.log('Error sharing', error));
    } else {
      console.log('navigator.share() not available')
      dispatch.modals.open({ name })
    }
  }

  const copy = (e) => {
    e.preventDefault();
    const copyText = document.getElementById(name+'id');
    copyText.select();
    document.execCommand("copy");
    dispatch.forms.update({ notice: 'Link has been copied' })
  }

  return (
    <>
      <IconButton key={name+'button'} noHover inline type="share" onClick={handleClick} size={28} stroke={color} />

      <Modal name={name} key={name+'modal'}>
        <center>
          <h5 style={{margin: 0, padding: '0.5em 0 1em'}}>Share</h5>
          {image ? (
            <Grid columns="100px 1fr" columnsMobile="100px 1fr" center>
              <Img
                square
                src={image}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  background: css.color.offwhitedark,
                  padding: '0 !important',
                  margin: '0 !important',
                }}
              />
              <h3 style={{margin: 0, padding: '0em 0 0.25em', textAlign: 'left'}}>{text}</h3>
            </Grid>
          ):(
            <h3 style={{margin: 0, padding: '0em 0 0.25em'}}>{text}</h3>
          )}
          <p style={{fontSize: '0.8em', marginBottom: 0}}>Click/tap below to copy url</p>
        </center>
        <div style={{textAlign: 'left'}}>
          <Input id={name+'id'} name={name+'field'} type="text" defaultValue={url} value={url} onFocus={copy} />
        </div>
      </Modal>
    </>
  )
}

export default Share